var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/SelectDependencies/ModelsTree/VersionButton/buttons/buttonStyles.tsx";
import makeStyles from '@mui/styles/makeStyles';
export var useBaseIconStyles = makeStyles(function () {
  return {
    root: {
      fontSize: '15px',
      color: '#A2A3B7'
    }
  };
});
export var useBaseButtonStyles = makeStyles(function (theme) {
  return {
    root: {
      minWidth: '30px',
      padding: '5px',
      paddingTop: '1.5px',
      paddingBottom: '1.5px',
      borderRadius: '5px',
      color: '#00003D',
      backgroundColor: theme.palette.grey[100],
      textTransform: 'none',
      transition: theme.transitions.create('backgroundColor', {
        duration: 1000
      }),
      '&:hover': {
        backgroundColor: theme.palette.grey[100]
      },
      cursor: 'default'
    },
    hover: {
      backgroundColor: '#00003D',
      color: '#fff'
    },
    text: {
      marginRight: '3px',
      fontSize: '10px'
    }
  };
});